import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import * as changeCase from 'change-case';

interface CategoryPillProps {
  label: string;
  isActive?: boolean;
  onClick?: () => void;
}

export default function CategoryPill({ label, isActive = false, onClick }: CategoryPillProps) {
  return (
    <motion.div whileHover={{ scale: 1.05 }}>
      <Button
        variant={isActive ? 'default' : 'secondary'}
        onClick={onClick}
        data-goal-id={'category_pill_clicked'}
        className={cn('rounded-3xl md:p-3 p-2 ')}
      >
        <span>{changeCase.sentenceCase(label)}</span>
      </Button>
    </motion.div>
  );
}
